// extracted by mini-css-extract-plugin
module.exports = {"container":"layout-module--container--621eS"};